export default __webpack_public_path__ + "static/media/admin.7f2a5aff.svg";